var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMydataicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbec0;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.95,
    y1: 176.1,
    x2: 313.41,
    y2: 176.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.6,206.6a46.1,46.1,0,0,0-16.7-16.7,44.73,44.73,0,0,0-23-6.1H148a45.58,45.58,0,0,0-39.7,22.8,42,42,0,0,0-4.3,10l56.7,56.7a19.62,19.62,0,0,0,27.8,0l57.1-57.1A36.8,36.8,0,0,0,241.6,206.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.4,93.8a46.61,46.61,0,0,0-46.8,0,47.75,47.75,0,0,0-17,17,46.61,46.61,0,0,0,0,46.8,47.75,47.75,0,0,0,17,17,46.61,46.61,0,0,0,46.8,0,47.75,47.75,0,0,0,17-17,46.61,46.61,0,0,0,0-46.8A47,47,0,0,0,198.4,93.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.2 239.4 102.2 241.4 108.2 245.4 102.2 239.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.7,314.65a40.19,40.19,0,0,1-28.59-11.86l-98.3-98.3a40.39,40.39,0,0,1,0-57.18L146.11,49a40.39,40.39,0,0,1,57.18,0l98.3,98.3a40.49,40.49,0,0,1,0,57.18l-98.3,98.3A40.17,40.17,0,0,1,174.7,314.65Zm0-260a22.76,22.76,0,0,0-16.21,6.74l-98.3,98.3a22.86,22.86,0,0,0,0,32.42l98.3,98.3a22.86,22.86,0,0,0,32.42,0l98.3-98.3a23,23,0,0,0,0-32.42l-98.3-98.3A22.76,22.76,0,0,0,174.7,54.65Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydataicon);
export default __webpack_public_path__ + "static/media/mydataicon.0baf78e7b21ad8f9518c46d844b9272f.svg";
export { ForwardRef as ReactComponent };